import speakingurl from 'speakingurl'

const generateSlug = (name) => speakingurl(name, { custom: { '&': '' } })

export default generateSlug
